"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = require("bind-decorator");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_toastify_1 = require("react-toastify");
const ecommerce_1 = require("../../api/ecommerce");
const Button_1 = __importDefault(require("../../common/js/atoms/Button"));
const NativeSelect_1 = __importDefault(require("../../common/js/atoms/NativeSelect"));
const ButtonVariant_1 = __importDefault(require("../../common/js/enums/ButtonVariant"));
const array_1 = require("../../common/js/helper/array");
const string_1 = require("../../common/js/helper/string");
const translation_1 = require("../../common/js/helper/translation");
const configuration_1 = __importDefault(require("../apis/configuration/shop/configuration"));
const ModalHeader_1 = __importDefault(require("../atoms/ModalHeader"));
const ChangeRequestChoices_1 = require("../constants/ChangeRequestChoices");
const ChangeRequestErrors_1 = __importDefault(require("../enums/ChangeRequestErrors"));
const CommonErrors_1 = __importDefault(require("../enums/CommonErrors"));
const error_1 = require("../helper/error");
const CustomerRoleStore_1 = __importDefault(require("../stores/CustomerRoleStore"));
const DepartmentStore_1 = __importDefault(require("../stores/DepartmentStore"));
const ChangeRequestAddress_1 = require("./change_request/ChangeRequestAddress");
const ChangeRequestContact_1 = require("./change_request/ChangeRequestContact");
const ChangeRequestGeneral_1 = require("./change_request/ChangeRequestGeneral");
class ChangeRequestModal extends react_1.default.Component {
    static mapping = new Map([
        [
            ecommerce_1.ChangeRequestObjectEnum.GeneralRequest,
            (props) => (react_1.default.createElement(ChangeRequestGeneral_1.ChangeRequestGeneral, { onChangeData: props.onChangeData, data: props.data, disabled: props.disabled })),
        ],
        [
            ecommerce_1.ChangeRequestObjectEnum.BillingAddress,
            (props) => (react_1.default.createElement(ChangeRequestAddress_1.ChangeRequestAddress, { onChangeData: props.onChangeData, data: props.data, disabled: props.disabled })),
        ],
        [
            ecommerce_1.ChangeRequestObjectEnum.ShippingAddress,
            (props) => (react_1.default.createElement(ChangeRequestAddress_1.ChangeRequestAddress, { onChangeData: props.onChangeData, data: props.data, disabled: props.disabled })),
        ],
        [
            ecommerce_1.ChangeRequestObjectEnum.CompanyAddress,
            (props) => (react_1.default.createElement(ChangeRequestAddress_1.ChangeRequestAddress, { data: props.data, disabled: props.disabled, onChangeData: props.onChangeData })),
        ],
        [
            ecommerce_1.ChangeRequestObjectEnum.AddressAddress,
            (props) => (react_1.default.createElement(ChangeRequestAddress_1.ChangeRequestAddress, { onChangeData: props.onChangeData, data: props.data, disabled: props.disabled })),
        ],
        [
            ecommerce_1.ChangeRequestObjectEnum.PersonalContact,
            (props) => (react_1.default.createElement(ChangeRequestContact_1.ChangeRequestContact, { onChangeData: props.onChangeData, data: props.data, disabled: props.disabled, edit: props.edit })),
        ],
        [
            ecommerce_1.ChangeRequestObjectEnum.CutterAssets,
            (props) => (react_1.default.createElement(ChangeRequestGeneral_1.ChangeRequestGeneral, { onChangeData: props.onChangeData, data: props.data, disabled: props.disabled })),
        ],
        [
            ecommerce_1.ChangeRequestObjectEnum.SoftwareAssets,
            (props) => (react_1.default.createElement(ChangeRequestGeneral_1.ChangeRequestGeneral, { onChangeData: props.onChangeData, data: props.data, disabled: props.disabled })),
        ],
    ]);
    api = new ecommerce_1.ChangeRequestApi(configuration_1.default);
    currentData = {};
    currentObject = null;
    currentTopic = null;
    isSubmitting = false;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            currentData: mobx_1.observable,
            currentObject: mobx_1.observable,
            currentTopic: mobx_1.observable,
            isSubmitting: mobx_1.observable,
        });
    }
    componentDidMount() {
        this.currentTopic = this.props.topic ?? null;
        this.currentObject = this.props.object ?? null;
        this.currentData = this.props.data ?? {};
    }
    render() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ModalHeader_1.default, { title: (0, translation_1.t)(this.props.title ?? 'change_request_modal.title'), classNamePrefix: "znd-change-request-modal", onCancel: this.props.onCancel }),
            react_1.default.createElement("form", { onSubmit: this.onSubmit },
                react_1.default.createElement("div", { className: "modal-body znd-modal__body znd-change-request-modal__body" },
                    react_1.default.createElement("div", { className: "znd-change-request-modal__choices" },
                        !this.props.topic
                            ? this.renderChoice((0, translation_1.t)('change_request_modal.topic'), (0, translation_1.t)('change_request_modal.select_topic'), Object.values(ecommerce_1.ChangeRequestTopicEnum), this.currentTopic, this.isSubmitting, (value) => {
                                this.currentTopic = value;
                                this.currentObject = null;
                            })
                            : null,
                        this.currentTopic && !this.props.object
                            ? this.renderChoice((0, translation_1.t)('change_request_modal.object'), (0, translation_1.t)('change_request_modal.select_object'), ChangeRequestChoices_1.ChangeRequestChoices[this.currentTopic], this.currentObject, this.isSubmitting, (value) => {
                                this.currentObject = value;
                            })
                            : null),
                    this.renderContent()),
                react_1.default.createElement("div", { className: "modal-footer znd-modal__footer znd-change-request-modal__footer" },
                    react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.secondary, text: (0, translation_1.t)('message_modal.cancel'), onClick: this.props.onCancel }),
                    react_1.default.createElement(Button_1.default, { className: "znd-change-request-modal__button", variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)(this.props.onDoneLabel ?? 'change_request_modal.on_done_label'), type: 'submit', disabled: !this.currentObject || this.isSubmitting })))));
    }
    renderChoice(label, placeholder, options, selectedOption, disabled, onChange) {
        const processedOptions = options.map((value) => {
            return {
                label: (0, translation_1.t)('change_request_modal.choices.' + value),
                value: value,
            };
        });
        return processedOptions ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h3", { className: "znd-change-request-modal__select-header t-body-small" },
                label,
                " ",
                react_1.default.createElement("span", { className: "required" }, "*")),
            react_1.default.createElement(NativeSelect_1.default, { alwaysShowPlaceholder: !selectedOption, noOptionPreselected: selectedOption === null, className: "znd-change-request-modal__select", disabled: disabled, onChange: onChange, options: processedOptions, placeholder: placeholder, required: true, value: selectedOption ? String(selectedOption) : '' }))) : null;
    }
    renderContent() {
        if (!this.currentObject) {
            return null;
        }
        const props = {
            onChangeData: this.onChangeData,
            data: this.currentData,
            disabled: this.isSubmitting,
            edit: this.props.edit,
        };
        const component = ChangeRequestModal.mapping.get(this.currentObject);
        return component ? component(props) : null;
    }
    onChangeData(data) {
        this.currentData = data;
    }
    onSubmit(event) {
        event.preventDefault();
        if (!this.currentTopic || !this.currentObject) {
            return;
        }
        this.isSubmitting = true;
        const data = { ...this.currentData };
        if ('department' in data && data.department) {
            data.department = (0, array_1.findRecord)(DepartmentStore_1.default.departments, 'value', data.department)?.label;
        }
        if ('role' in data && data.role) {
            data.role = (0, array_1.findRecord)(CustomerRoleStore_1.default.roles, 'value', data.role)?.label;
        }
        if (this.currentTopic === ecommerce_1.ChangeRequestTopicEnum.Contact && this.props.edit && 'email' in data && data.email) {
            delete data.email;
        }
        if ('website' in data && data.website) {
            data.website = (0, string_1.ensureURLWithHTTPS)(data.website);
        }
        this.api
            .sendChangeRequest({
            changeRequest: {
                topic: this.currentTopic,
                object: this.currentObject,
                data: data,
            },
        })
            .then(() => {
            react_toastify_1.toast.success((0, translation_1.t)('change_request_modal.send_success', { object: this.currentObject }));
            this.props.onDone();
        })
            .catch((response) => (0, error_1.handleErrorResponse)(response).then((errorResponse) => {
            if (!errorResponse?.errors) {
                return;
            }
            const error = (0, array_1.first)(errorResponse.errors ?? []);
            let errorCode = '';
            if (error?.code == ChangeRequestErrors_1.default.ErrorCodeSalesForceDuplicate) {
                errorCode = 'duplicate_salesforce';
            }
            if (error?.meta?.violationCode === ChangeRequestErrors_1.default.ViolationCodeDuplicateEmail) {
                errorCode = 'duplicate_email';
            }
            if (error?.meta?.violationCode === ChangeRequestErrors_1.default.TaxIdInvalid) {
                errorCode = 'tax_id_invalid';
            }
            if (error?.code === CommonErrors_1.default.TaxIdUpdateFailed) {
                errorCode = 'tax_id_update_failed';
            }
            react_toastify_1.toast.error((0, translation_1.t)('change_request_modal.send_error', { object: errorCode }));
        }))
            .finally(() => {
            this.isSubmitting = false;
        });
    }
}
__decorate([
    bind_decorator_1.bind
], ChangeRequestModal.prototype, "renderContent", null);
__decorate([
    bind_decorator_1.bind
], ChangeRequestModal.prototype, "onChangeData", null);
__decorate([
    bind_decorator_1.bind
], ChangeRequestModal.prototype, "onSubmit", null);
exports.default = (0, react_i18next_1.withTranslation)()((0, mobx_react_1.observer)(ChangeRequestModal));
